export default __webpack_public_path__ + "static/media/undraw_Cautious_dog_q83f.a0285ced.svg";